import { createSelector } from 'reselect';

export const selectedManagerLegelProceedings = (state: any) => {
  return state.get('managerLegalProceedings');
};
const makeSelectCheckCivilPartyJudiciaryProcess = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (
      legalProceeding &&
      legalProceeding.get('checkCivilPartyJudiciaryProcess')
    ) {
      return legalProceeding.get('checkCivilPartyJudiciaryProcess').toJS();
    }
    return null;
  });
const makeSelectDecisionJudgmentIds = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('decisionJudgementIds')) {
      return legalProceeding.get('decisionJudgementIds').toJS();
    }
    return null;
  });
const makeSelectClaimHistoryActions = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('claimHistoryActions')) {
      return legalProceeding.get('claimHistoryActions').toJS();
    }
    return [];
  });
const makeSelectClaimHistorySagis = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('claimHistorySagis')) {
      return legalProceeding.get('claimHistorySagis').toJS();
    }
    return [];
  });
const makeInstructions = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('instructions')) {
      return legalProceeding.get('instructions').toJS();
    }
    return [];
  });
const makeSelectPendingTasksClaim = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('pendingTasksClaim')) {
      return legalProceeding.get('pendingTasksClaim').toJS();
    }
    return [];
  });
const makeSelectClaimCivilParty = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('claimCivilParty')) {
      return legalProceeding.get('claimCivilParty').toJS();
    }
    return [];
  });

const makeSelectDecisionFlowVictim = () =>
  createSelector(selectedManagerLegelProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('decisionFlowVictim')) {
      return legalProceeding.get('decisionFlowVictim').toJS();
    }
    return [];
  });
export {
  makeSelectCheckCivilPartyJudiciaryProcess,
  makeSelectDecisionJudgmentIds,
  makeSelectClaimHistoryActions,
  makeSelectClaimHistorySagis,
  makeInstructions,
  makeSelectPendingTasksClaim,
  makeSelectClaimCivilParty,
  makeSelectDecisionFlowVictim,
};
